import { makeStyles } from "@material-ui/core/styles";
import { primary } from "../../../../assets/variables.module.scss";
import yellowLineDecoration from "../../../../assets/img/yellowLineDecoration.png";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "60vw",
  },
  paragraphContainer: {
    marginBottom: theme.spacing(3),
  },
  listIcon: {
    width: theme.spacing(2),
    marginRight: theme.spacing(1),
    color: primary,
  },
  listText: {
    width: `calc(100% - ${theme.spacing(3)}px)`,
  },
  decorationBackground: {
    height: 70,
    marginBottom: theme.spacing(3),
    backgroundImage: `url(${yellowLineDecoration})`,
    backgroundSize: "100% 100%",
  },
  horizontalPadding: {
    padding: `0 ${theme.spacing(5)}px`,
  },
}));

export default useStyles;
